import styled from 'styled-components';

export const BlurContent = styled.span`
  color: transparent;
  text-shadow: 0 0 8px #000;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;
